// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__WLQbC","archiveButton":"style_archiveButton__gzoWY"};